module.exports = __webpack_public_path__ + "img/light.675e88dd.jpg";